import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@massilia/ui'

interface AcceptEstimateDialogProps {
  responseName: string
  isOpen: boolean
  onConfirm: () => void
  onOpenChange: (open: boolean) => void
  /** Nombre d'autres propositions encore vivantes sur la même demande. */
  otherLiveResponsesCount: number
}

/**
 * Confirmation avant le formulaire de réservation.
 *
 * Le refus automatique des autres propositions est annoncé AVANT le clic : c'est
 * un effet irréversible sur des offres que le client était en train de comparer.
 */
export function AcceptEstimateDialog({
  responseName,
  isOpen,
  onConfirm,
  onOpenChange,
  otherLiveResponsesCount,
}: AcceptEstimateDialogProps) {
  return (
    <Dialog onOpenChange={onOpenChange} open={isOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Confirmer « {responseName} »</DialogTitle>
          <DialogDescription>
            Vous allez remplir les informations des voyageurs pour finaliser votre demande de
            réservation.
          </DialogDescription>
        </DialogHeader>

        {otherLiveResponsesCount > 0 && (
          <p className="text-sm text-gray-light-700">
            En confirmant cette proposition, les {otherLiveResponsesCount} autres propositions de
            cette demande seront automatiquement déclinées.
          </p>
        )}

        <DialogFooter>
          <Button onClick={() => onOpenChange(false)} type="button" variant="ghost">
            Annuler
          </Button>
          <Button
            className="bg-brand-600 text-white hover:bg-brand-700"
            onClick={onConfirm}
            type="button"
          >
            Continuer
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
